import { deserialize, serialize, inheritSerialization, serializeAs, deserializeAs } from "cerialize";
import BaseEntity from "../BaseEntity";
import TUKAllowedItem from "./TUKAllowedItem";
import TableColumn from "../TableColumn";
import { getVm } from "@/util/GlobalVm";

@inheritSerialization(BaseEntity)
export default class TUKConfig extends BaseEntity {

    @serialize
    @deserialize
    public user_id: string = "";

    @serialize
    @deserialize
    public email: string = "";

    @serialize
    @deserialize
    public username: string = "";

    @serialize
    @deserialize
    public bendahara_type: string = "";

    @serialize
    @deserializeAs((json: any) => json || [])
    public wilayah_access: string[] = [];

    @serializeAs(TUKAllowedItem)
    @deserializeAs(TUKAllowedItem)
    public allowed_jenis_pemasukan: TUKAllowedItem[] = [];

    @serialize
    @deserialize
    public is_active: boolean = false;

    @serialize
    @deserialize
    public item_pembayaran_access: number[] = [];

    public table(): any {
        return {
            username: this.username,
            email: this.email,
            bendahara_type: this.bendahara_type,
            wilayah_access: this.wilayah_access,
            is_active: this.is_active
        };
    }

    public static columnName(): Array<any> {
        const config = new TUKConfig().table();
        let keys = Object.keys(config);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = getVm().$t(`label.${field}`);
            return tableColumn;
        });
    }
}
